// Implements: F-UIX-018
/**
 * The label of each audited action (UIX.7), by its server token. Dictionary keys are camel case
 * (AD-05), the tokens are snake case, so the mapping is written out: a token the server adds
 * without a line here does not compile once it joins `AUDIT_ACTIONS`.
 */

import type { TranslationKey } from "../../../shared/i18n";
import type { AuditAction } from "../../../types/audit";

export const ACTION_LABEL_KEYS = {
  mockup_created: "backoffice.audit.action.mockupCreated",
  mockup_scope_changed: "backoffice.audit.action.mockupScopeChanged",
  mockup_trashed: "backoffice.audit.action.mockupTrashed",
  mockup_restored: "backoffice.audit.action.mockupRestored",
  mockup_deleted: "backoffice.audit.action.mockupDeleted",
  version_generated: "backoffice.audit.action.versionGenerated",
  share_link_created: "backoffice.audit.action.shareLinkCreated",
  share_link_expiry_changed: "backoffice.audit.action.shareLinkExpiryChanged",
  share_link_revoked: "backoffice.audit.action.shareLinkRevoked",
  share_link_revoked_by_system: "backoffice.audit.action.shareLinkRevokedBySystem",
  share_password_failed: "backoffice.audit.action.sharePasswordFailed",
  login_failed: "backoffice.audit.action.loginFailed",
  login_blocked: "backoffice.audit.action.loginBlocked",
  usage_ceiling_changed: "backoffice.audit.action.usageCeilingChanged",
  usage_distribution_changed: "backoffice.audit.action.usageDistributionChanged",
  sender_linked: "backoffice.audit.action.senderLinked",
  sender_unlinked: "backoffice.audit.action.senderUnlinked",
  design_profile_renamed: "backoffice.audit.action.designProfileRenamed",
} as const satisfies Record<AuditAction, TranslationKey>;
